import {
  ICondHooksProps,
  TComponentConfig,
  TComponentConfigType,
  TFilterConfigProps,
} from '../types';
import * as config from '../config';
import { useMemo } from 'react';
import { useFilterCondData } from './useFilterCondData';

function addCondConfig(
  keys: ICondHooksProps['keys'],
  condConfig: { [key: string]: any },
  filterConfigProps?: TFilterConfigProps,
) {
  const defaultDealwith = (config: { [key: string]: any }, key: string) =>
    config[key];

  return keys.map(key => {
    const configItem = config[key];
    const { requestKey, condDealwith = defaultDealwith, props } = configItem as TComponentConfig<any>;
    const propsConfig = filterConfigProps?.[key] || {};
    if (requestKey) {
      return {
        ...configItem,
        key,
        props: {
          ...props,
          ...propsConfig,
          options: condDealwith(condConfig, requestKey),
        },
      };
    }

    return {
      key, ...configItem, props: {
        ...props,
        ...propsConfig,
      },
    };
  });
}

export function useFilterCond({
  keys,
  backCondConfig,
  extrRequestKeys = [],
  filterConfigProps,
  condGameIds,
}: ICondHooksProps & {
  filterConfigProps?: TFilterConfigProps;
  condGameIds?: string[];
}) {
  const { loading, condData } = useFilterCondData({
    keys,
    backCondConfig,
    extrRequestKeys,
    condGameIds,
  });

  const renderConfig = useMemo<TComponentConfigType<any>[]>(() => {
    if (loading) {
      return [];
    }
    return addCondConfig(keys, condData, filterConfigProps);
  }, [loading, condData, keys]);

  return { loading, renderConfig };
}
